import {
  deleteImage,
  getImageMonths,
  getImagesPage,
  updateImageTags,
} from '@/api/images';
import { ImageMonth, ImagesState, PaginatedImagesResult } from '@/types/image';
import { RootState } from '@/types/store';
import { Tag } from '@/types/tag';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type ImagesGetter = GetterTree<ImagesState, RootState>;

const state: ImagesState = {
  data: [],
  current_page: 1,
  last_page: 1,
  imageMonths: [],
};

const getters: ImagesGetter = {
  images: state => state.data,
  imageMonths: state => {
    const all: ImageMonth = { text: 'All', value: 'all' };
    return [all].concat(state.imageMonths);
  },
};

const actions: ActionTree<ImagesState, RootState> = {
  async getImageMonths({ commit }): Promise<void> {
    commit('setImageMonths', await getImageMonths());
  },
  async getPage({ commit }, { page, filters }): Promise<void> {
    commit('setPage', await getImagesPage(page, filters));
  },
  async deleteImage({ commit, dispatch }, { id }): Promise<void> {
    try {
      await deleteImage(id);
      dispatch('getPage', { page: 1 });
    } catch (error: any) {
      commit('notifications/addNotification', {
        text: 'Oops! Your image could not be deleted.',
        colour: 'red',
        top: true,
        right: true,
      });
    }
  },
  async updateTags({ commit }, { id, tags }): Promise<void> {
    try {
      const updatedTags: Tag[] = await updateImageTags(id, tags);
      commit('setImageTags', { id, updatedTags });
    } catch (error: any) {
      commit('notifications/addNotification', {
        text: 'Oops! Your image could not be deleted.',
        colour: 'red',
        top: true,
        right: true,
      });
    }
  },
};

const mutations: MutationTree<ImagesState> = {
  setImageMonths(state: ImagesState, imageMonths: ImageMonth[]): void {
    state.imageMonths = imageMonths;
  },
  setImageTags(
    state: ImagesState,
    { id, updatedTags }: { id: string; updatedTags: Tag[] },
  ): void {
    const image = state.data.find(i => i.id === id);
    if (image) {
      image.tags = updatedTags;
    }
  },
  setPage(
    state: ImagesState,
    { data, current_page, last_page }: PaginatedImagesResult,
  ): void {
    if (current_page === 1) {
      Object.assign(state, { data, current_page, last_page });
    } else {
      Object.assign(state, {
        data: state.data.concat(data),
        current_page,
        last_page,
      });
    }
  },
};

const images: Module<ImagesState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default images;
